import { qualitiesApi } from '@texas/api/endpoints/metadata/qualitiesApi';
import { SearchQuery, EntityItem } from '../../../types';
import { randomIdentifier } from '@texas/utils/helpers/commonHelpers';
import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';

export async function searchQuality(query: SearchQuery): Promise<EntityItem[]> {
  const response = await qualitiesApi.getAll({
    searchTerm: query.query,
    sortBy: '',
    sortDesc: false,
    includeArchived: false,
    preciseIdFiltering: false,
    productGroupId: null,
    vdcSupport: false,
  });

  if (response.hasError) {
    return [];
  }

  return response.data.map((c) => ({
    id: c.id,
    name: c.name,
    type: ChatMessageEntityLinkType.Quality,
    identifier: randomIdentifier(),
  }));
}
